import { render, staticRenderFns } from "./AuthPrompt.vue?vue&type=template&id=09b09ac4"
import script from "./AuthPrompt.vue?vue&type=script&lang=js"
export * from "./AuthPrompt.vue?vue&type=script&lang=js"
import style0 from "./AuthPrompt.vue?vue&type=style&index=0&id=09b09ac4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports